export default "__VITE_ASSET__Cb48fpU3__"